var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSendSmsOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-sendSMS-off_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-sendSMS-off_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#F3F4F8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DADEE5",
  d: "m8.355 10.193 6.346 5.633c.45.397 1.128.397 1.577 0l6.384-5.672.555-.533A3.54 3.54 0 0 0 21.219 9H9.75c-.726 0-1.405.223-1.969.601l.564.592z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DADEE5",
  d: "m23.8 11.373-6.528 5.602a2.72 2.72 0 0 1-3.527 0l-6.517-5.583-.614-.61A3.47 3.47 0 0 0 6 12.756v5.725c0 1.976 1.637 3.579 3.653 3.579h11.691c2.017 0 3.653-1.603 3.653-3.579v-5.716c0-.716-.224-1.383-.594-1.947l-.604.563z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M23.523 26.028a4.947 4.947 0 1 0 0-9.894 4.947 4.947 0 0 0 0 9.894"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DADEE5",
  d: "M26.205 21.299a.55.55 0 0 0 0-.436.5.5 0 0 0-.13-.188l-1.78-1.79a.57.57 0 0 0-.812 0 .567.567 0 0 0 0 .81l.812.812h-2.91a.574.574 0 0 0 0 1.148h2.91l-.812.811a.567.567 0 0 0 0 .812.58.58 0 0 0 .406.168c.149 0 .297-.06.406-.168l1.78-1.781a.6.6 0 0 0 .13-.188z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-sendSMS-off_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-sendSMS-off_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})))));
export default SvgIcSendSmsOff;